document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("cart");
  
  function updatePalletFormDisplay() {
    const palletForm = document.querySelector(".pallet-details");
    if (!palletForm) return;
    const cartItems = Array.from(document.querySelectorAll("tr.cart-item"));
    // Find a matching
    const foundItem = Array.from(cartItems).find((cartItem) => {
      const details = cartItem.querySelector(".cart-item__details");
      if (!details) return false;

      const productOptions = details.querySelectorAll(".product-option dd");
      return Array.from(productOptions).some(
        (dd) => dd.textContent.trim().toLowerCase() === "pallet"
      );
    });
    if (!foundItem) {
      palletForm.parentNode.removeChild(palletForm);
    }
  }

  if (form) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if ((mutation.target = "div.js-contents")) {
          updatePalletFormDisplay();
        }
      });
    });

    // Configuration options:
    const config = { childList: true, subtree: true }; // Detect when items are added/removed
    observer.observe(form, config);
  }
});
